import React from 'react';

interface Props {
  alerts: string[]; 
}

const SensitiveAlertsBanner = ({ alerts }: Props) => {
  if (!alerts || alerts.length === 0) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', margin: '10px 0' }}>
      {alerts.map((messageText, index) => (
        <div
          key={index}
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            padding: '10px 12px',
            backgroundColor: '#FFF3CD', 
            border: '1px solid #FFEEBA',
            borderRadius: '8px',
            color: '#856404',
            fontSize: '13px',
            lineHeight: '1.4'
          }}
        >
          <span style={{ marginRight: '8px', fontSize: '16px' }}>⚠️</span>
          <span>{messageText}</span>
        </div>
      ))}
    </div>
  );
};

export default SensitiveAlertsBanner;